import React, { useContext, useState } from 'react'
import { Avatar } from '@readyplayerme/visage'
import AvatarLink from '../../components/avatars/AvatarLink'
import PrimaryButton from '../../components/buttons/PrimaryButton'
import SecondaryButton from '../../components/buttons/SecondaryButton'
import { motion } from 'framer-motion'
import Loading from '../../components/common/Loading'
import ArrowLeft from '../../components/icons/ArrowLeft'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import useApi from '../../hooks/useApi'
import { getUserAvatar } from '../../api/supabaseApi'
const AvatarCreator = () => {
  const navigate = useNavigate()
  const [avatarLoaded, setAvatarLoaded] = useState(false)
  const {
    session: { user },
  } = useContext(AuthContext)
  const { data } = useApi(() => getUserAvatar(user.id), [user])

  const onLoaded = () => {
    setAvatarLoaded(true)
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
      className="md:container mx-auto md:px-4 min-h-screen md:min-h-full"
    >
      <div className="bg-white p-6 w-full mx-auto rounded-lg shadow max-w-[648px]">
        <div className="flex justify-between gap-6 items-center mb-6 md:hidden">
          <a onClick={() => navigate(-1)}>
            <ArrowLeft size="7" color="#212121" />
          </a>
          <p className="text-3xl inline-block text-black font-normal text-center">
            Create your avatar
          </p>
          <div></div>
        </div>

        <div className="flex flex-col-reverse md:flex-col">
          <div>
            <p className="text-3xl text-primary font-bold text-center mb-6">
              Meet your avatar
            </p>
            <p className="text-base font-normal text-center text-black mb-6">
              This avatar represents you in the MADverse as you embark on your
              Purpose Quest. It will evolve alongside your journey of
              self-discovery and global impact..
            </p>
          </div>
          <div className="w-full mx-auto meet-your-avatar relative mb-4">
            {!avatarLoaded && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <Loading />
              </div>
            )}
            <Avatar
              onLoaded={onLoaded}
              style={{ height: '444px' }}
              modelSrc={data?.readyplayer_url}
            />
          </div>
        </div>
        <div className="mt-4">
          <div className="hidden md:block">
            <p className="text-base font-bold text-center text-black mb-4">
              Copy the link to share in social media
            </p>
            <AvatarLink avatarUrl={data?.readyplayer_url} />
          </div>
          <div className="mt-6 flex gap-4">
            <SecondaryButton
              className="hidden md:flex w-full"
              to="/create-avatar"
            >
              Back
            </SecondaryButton>
            <PrimaryButton className="w-full" to="/avatar-success">
              Begin Your Journey
            </PrimaryButton>
          </div>
          <p className="text-base font-nomal text-center text-grey-700 mt-4">
            You can customize your avatar anytime from your profile settings.
          </p>
        </div>
      </div>
    </motion.div>
  )
}

export default AvatarCreator
